import { useMeterReadingSummary } from "@features/bx/BulkBillGeneration/hooks";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { AlertCircle, Calculator, FileText, Users } from "lucide-react";
import { useParams } from "react-router-dom";

export const GenerateBillSummary = () => {
  const { id, cycleId } = useParams();
  const { data: meterReadingSummary } = useMeterReadingSummary(cycleId);
  const meterAnalysisCards = [
    {
      title: "Total Consumers",
      count: meterReadingSummary?.summaryCards?.totalConsumers ?? 0,
      icon: <Users className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Actual Bills",
      count: meterReadingSummary?.summaryCards?.actualBills ?? 0,
      icon: <FileText className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Estimated Bills",
      count: meterReadingSummary?.summaryCards?.estimatedBills ?? 0,
      icon: <Calculator className="h-8 w-8 text-yellow-500" />,
    },
    {
      title: "Unbilled",
      count: meterReadingSummary?.summaryCards?.unbilledConsumers ?? 0,
      icon: <AlertCircle className="h-8 w-8 text-red-500" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
      {meterAnalysisCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          icon={card.icon}
        />
      ))}
    </div>
  );
};
